export default __webpack_public_path__ + "static/media/StepBg1.f69e6910.svg";